import { Configuration, LogLevel } from '@azure/msal-browser';

export const msalConfig: Configuration = {
  auth: {
    clientId: process.env.REACT_APP_AZUREAD_CLIENT_ID!,
    authority: `https://login.microsoftonline.com/${process.env.REACT_APP_AZUREAD_TENANT_ID}`,
    redirectUri: process.env.REACT_APP_AZUREAD_REDIRECT_URL,
    postLogoutRedirectUri: '/',
  },
  cache: {
    cacheLocation: 'localStorage',
    storeAuthStateInCookie: false,
  },
  system: {
    loggerOptions: {
      loggerCallback: (
        level: LogLevel,
        message: string,
        containsPii: boolean
      ) => {
        if (containsPii) {
          return;
        }
        switch (level) {
          case LogLevel.Error:
            //console.error(message);
            return;
          case LogLevel.Info:
            //console.info(message);
            return;
          case LogLevel.Verbose:
            //console.debug(message);
            return;
          case LogLevel.Warning:
            //console.warn(message);
            return;
        }
      },
    },
  },
};

export const protectedResources = {
  apiAtlas: {
    endpoint: process.env.REACT_APP_API_URL,
    scopes: {
      read: [`${process.env.REACT_APP_AZUREAD_APP_URI}/users.read`],
      write: [`${process.env.REACT_APP_AZUREAD_APP_URI}/users.write`],
    },
  },
};

export const loginRequest = {
  scopes: [
    ...protectedResources.apiAtlas.scopes.read,
    ...protectedResources.apiAtlas.scopes.write,
  ],
};
